import { useNavigate } from 'react-router-dom'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import EditLeave from 'modules/timeoff/components/EditLeave'
import LeaveRecommendationModal from 'modules/timeoff/components/LeaveRecommendationModal'
import { useLeaveRecommendationFeatureFlag } from 'modules/timeoff/hooks/useLeaveRecommendationFeatureFlag'
import { useOnClose } from 'modules/timeoff/hooks/useOnClose'

const EditLeavePage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const onClose = useOnClose()

  const { leave_id: leaveId } = useStrictParams<'leave_id'>()

  const onReject = () => {
    if (leaveId) {
      navigate(navigation.timeOff.leavesRejectLeaveId.fullPath({ leave_id: leaveId }))
    }
  }

  const { loading } = useAsyncData(
    () => contractVersions.fetch({ withCachedFetchParams: true }),
    []
  )

  const { loading: ffLoading, enabled: isRecommendationEnabled } =
    useLeaveRecommendationFeatureFlag()
  const showRecommendationModal = !ffLoading && isRecommendationEnabled

  if (!leaveId) {
    return null
  }

  return showRecommendationModal ? (
    <LeaveRecommendationModal
      leaveId={Number(leaveId)}
      onClose={onClose}
      onChange={onClose}
      onReject={onReject}
      contractVersions={contractVersions}
      loading={loading}
      fromShifts={false}
    />
  ) : (
    <EditLeave
      leaveId={Number(leaveId)}
      onClose={onClose}
      onReject={onReject}
      onChange={onClose}
      contractVersions={contractVersions}
      loading={loading}
      fromShifts={false}
    />
  )
}

export default EditLeavePage
